import React from "react"
import Link from "gatsby-link"
import Img from "gatsby-image"

export default ({ imgSizes, downloads, title }) =>
	<div>
		<div css={{ margin: `0 0.5rem` }}>
			<Link css={{ float: `right` }} to="/">Back</Link>
			<h3>{title}</h3>
		</div>
		<Img sizes={imgSizes}/>
		<p css={{
			textAlign: `center`,
			marginTop: `1em`,
		}}>
			Downloads: <a href={downloads.med} download>medium</a> / <a href={downloads.lrg} download>large</a>
		</p>
	</div>



// WEBPACK FOOTER //
// ./src/components/BoardPage.js